import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { QueryTypes } from "./shared";
import PremierPlusSettingHistoryRecordDTO from "src/models/PremierPlusSettingHistoryRecordDTO";


export const useGetPremierPlusBinSettingsHistoryQuery = (binId: number | null | undefined, from: string | null, to: string | null, options: QueryTypes = {}) => {
    const getPremierPlusBinSettingsHistoryQueryKey = "getPremierPlusBinSettingsHistoryQuery";

    const getPremierPlusBinSettingsHistoryQuery = useQuery<PremierPlusSettingHistoryRecordDTO[]>({
        queryKey: [getPremierPlusBinSettingsHistoryQueryKey, binId, from, to],
        queryFn: async (q) => {
            if(binId != null){
                return await BinApiService.getPremierPlusBinDryingSettingsHistory(binId, from, to, q.signal);   
            }
            return [];
        },
        enabled: options.enabled,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    })

    return { getPremierPlusBinSettingsHistoryQueryKey, getPremierPlusBinSettingsHistoryQuery };

}